import { ASSETS } from "../../../assets";
import Logo from "../../logo";
import { useState } from 'react';
import { Link } from 'react-router-dom'
import { pages } from "../../../config/routes";
import './styles.scss';

function MobileNavigation() {
  const CLASS_NAME = "mobile-navigation"
  const [isOpened, setIsOpened] = useState(false);
  const changeMenuState = !isOpened ? "closed" : "open";
  const showBorder = isOpened ? "hide-border" : "";

  return (
    <>
    <nav className={`${CLASS_NAME} ${showBorder}`}>
      <div className={`${CLASS_NAME}-container`}>
        <Logo />
        <img src={ASSETS.HAMBURGER_ICON} alt="Menu Icon" className={`${CLASS_NAME}-menu-icon`} onClick={() => {
          setIsOpened(!isOpened)
        }} />
      </div>
    </nav>
      <ul className={`${CLASS_NAME}-links ${changeMenuState} flex-column`}>
        <li><Link to={pages.home} onClick={() => setIsOpened(false)}>Home</Link></li>
        <li><Link to={pages.capabilities} onClick={() => setIsOpened(false)}>Capabilities</Link></li>
        <li><Link to={pages.contact} onClick={() => setIsOpened(false)}>Contact</Link></li>
        <li><Link to={pages.whyKeyes2Safety} onClick={() => setIsOpened(false)}>Why Keyes2Safety?</Link></li>
      </ul>
    </>
  );
}

export default MobileNavigation;